<template>
  <div class="header">
    <!-- logo -->
    <div class="logo" @click="collapseBtn">
      <img src="@/image/nav_icon/daohang.png" alt="" srcset="" style="width: 100%;" v-if="isCollapse" />
      <img src="@/image/nav_icon/zhedie.png" alt="" srcset="" style="width: 100%;" v-else />
    </div>
    <div class="right">
      <!-- <div class="badge">
        通知
        <el-badge class="mark" :value="0" />
      </div> -->
      <!-- 用户 -->
      <div class="right_dom1" @click="handleExit">
        <img src="@/image/user.png" alt="" srcset="" style="width: 40px;height:40px" />
        <!-- 身份 -->
        <div>
          {{
            userInfo.title
          }}
          -
          {{ userInfo.username ? userInfo.username : "请登录账号" }}
        </div>
        <!-- 切换账号 -->
        <div class="handleExit">
          <el-tooltip class="item" effect="dark" content="切换账号" placement="bottom">
            <img src="@/image/header/icon.png" alt="" srcset="" style="width: 15px;height:15px;" />
          </el-tooltip>
        </div>
      </div>
      <!-- 切换全屏 -->
      <img class="handleFullScreen" @click="handleFullScreen" :src="!isFullscreen
            ? require('../../image/header/quanping.png')
            : require('../../image/header/quxiaoquanping.png')
          " alt="" srcset="" style="width: 40px;height:40px;display: block;" />
    </div>
  </div>
</template>

<script>
import { loginOut } from "@/services/user/index";
import { mapState } from "vuex";
import screenfull from "screenfull";
export default {
  props: {
    role: {
      type: Number,
    },
  },
  data() {
    return {
      isCollapse: false,
      isFullscreen: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    // screenfull在这里有一个on方法，监控事件的触发
    screenfull.on("change", () => {
      this.isFullscreen = screenfull.isFullscreen;
    });
  },
  methods: {
    collapseBtn() {
      this.isCollapse = !this.isCollapse;
      this.$emit("collapse", this.isCollapse);
    },
    /* 退出账号 */
    handleExit() {

      this.$confirm("我们会继续保留您的账号数据，确认退出?", "退出登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({ name: "Login" });
        loginOut({ id: this.userInfo.id }).then((resp) => {
          this.$message({
            type: "success",
            message: "已注销登录!",
          });
        });
      });
    },
    /* 全屏 */
    handleFullScreen() {
      if (!screenfull.enabled) {
        this.$message.info("您的浏览器版本过低，不支持全屏浏览");
        return false;
      }
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
  },
};
</script>

<style scoped lang="less">
.badge:hover {
  color: rgb(31, 129, 235);
  cursor: pointer;
}

.header {
  position: relative;
  height: 60px;
  background: #fff;
  line-height: 60px;
  display: flex;
  background: #edf3ff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  align-items: center;
}

.header>.logo {
  margin-left: 20px;
  width: 22px;
}

.header>.logo:hover {
  cursor: pointer;
}

/* 用户 */
.right {
  width: 450px;
  position: absolute;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // border:1px solid rgb(0, 0, 0);
}

.right_dom1 {
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // border:1px solid red;
  img {
    margin-right: 10px;
  }
}

.right_dom1:hover {
  cursor: pointer;
  color: rgb(31, 129, 235);
}

/* 退出登录 */
.handleExit {
  margin: 0 5px;
}

.handleExit:hover {
  cursor: pointer;
}

.handleFullScreen:hover {
  cursor: pointer;
}
</style>
